import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Phase 0 of the new hourly/daily/weekly/bi-weekly payroll module: employee
// pay-basis assignment and the per-employee wage-rate master. Monthly
// payroll itself keeps running in CI4 (unchanged) until later phases.
const GlobalPayrollTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    {
      name: "Pay Basis",
      path: "/global-payroll/pay-basis",
    },
    {
      name: "Wage Rates",
      path: "/global-payroll/wage-rates",
    },
    {
      name: "Payroll Templates",
      path: "/global-payroll/payroll-templates",
    },
    {
      name: "Payroll Runs",
      path: "/global-payroll/payroll-runs",
    },
    {
      name: "Monthly Parity",
      path: "/global-payroll/monthly-parity",
    },
  ];

  useEffect(() => {
    const isValidPath = tabs.some(
      (tab) => location.pathname === tab.path || location.pathname.startsWith(`${tab.path}/`)
    );

    if (!isValidPath) {
      navigate(tabs[0].path, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, navigate]);

  return (
    <ul className="nav nav-tabs" role="tablist">
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.path || location.pathname.startsWith(`${tab.path}/`);

        return (
          <li className="nav-item" key={tab.path}>
            <button type="button" className={`nav-link ${isActive ? "active" : ""}`} onClick={() => navigate(tab.path)}>
              {tab.name}
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default GlobalPayrollTabs;
